<template>
  <div class="data-center" v-if="isH5Plus()">
    <div class="out out-h5plus" >
      <Out/>
    </div>
  </div>
  <div class="data-center" v-else>
    <div class="white-bg">
      <van-tabs v-model="activeName" class="tabs-wrapper">
        <van-tab v-for="(item) in tabsArr" :key="item.title" :title="item.title" :name="item.name">
        </van-tab>
      </van-tabs>
    </div>
    <div class="total" v-if="activeName === 'all'">
      <All/>
    </div>
    <div class="out"  v-if="activeName === 'out'">
      <Out/>
    </div>
    <div class="in"  v-if="activeName === 'in'">
      <In/>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs
} from 'vant'
import All from './All'
import Out from './Out'
import In from './In'
import { isH5Plus } from '@/utils/basicUtil'
export default {
  data: () => ({
    activeName: 'all',
    tabsArr: [
      {
        name: 'all',
        title: '总'
      },
      {
        name: 'out',
        title: '开'
      },
      {
        name: 'in',
        title: '收'
      }
    ]
  }),
  async mounted () {
    if (this.$store.state.user.userInfo.innerFlag === 3) {
      await this.tabsArr.shift()
      this.activeName = 'out'
    }
  },
  methods: {
    isH5Plus () {
      return isH5Plus()
    }
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    All,
    Out,
    In
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
